/**
 * Date helpers — single source of truth for handling YYYY-MM-DD strings safely
 * across timezones.
 *
 * Why this exists:
 *   • `new Date("2026-05-10")` is parsed by JS as UTC midnight, which then renders
 *     as the day BEFORE for users west of UTC and the day AFTER for some operations
 *     east of UTC.
 *   • `Date.prototype.toISOString()` always returns UTC, so calling
 *     `.toISOString().split('T')[0]` on a locally-constructed Date can shift the
 *     calendar day depending on the user's timezone.
 *
 * Use these helpers for every "calendar-day" date — appointment booking, due
 * dates, cohort dates, etc.  Never use `new Date(ymd)` directly.
 */

export const toLocalYMD = (date) => {
  if (!(date instanceof Date) || Number.isNaN(date.getTime())) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

export const parseLocalDate = (ymd) => {
  if (!ymd) return new Date(NaN);
  const [y, m, d] = String(ymd).split('-').map(Number);
  return new Date(y, (m || 1) - 1, d || 1);
};

export const formatLocalDate = (ymd, opts) =>
  parseLocalDate(ymd).toLocaleDateString(undefined, opts);

export const todayYMD = () => toLocalYMD(new Date());
